import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-1 py-0 text-primary fw-bold" }

import { storeToRefs } from 'pinia';
import useGamificationAccountStore from '@/stores/gamification/gamificationAccountStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GamificationUserBalance',
  setup(__props) {

const gamificationAccountStore = useGamificationAccountStore();
const { balance } = storeToRefs(gamificationAccountStore);

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_component_ion_button, {
    shape: "round",
    fill: "solid",
    color: "light",
    strong: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(balance)) + " 🍋 ", 1)
    ]),
    _: 1
  }))
}
}

})